import { useContext } from 'react';
import StoreContext from '../store/context/StoreContext';
import { RootStoreType } from '../store/context/types';

export const useStore = (): RootStoreType => {
  const store = useContext(StoreContext);

  if (!store) {
    throw new Error('useStore must be used within a StoreContext.Provider');
  }

  return store;
};

export default useStore;
